import { Box, Checkbox, FormControlLabel } from "@mui/material"
import type { ChangeEvent, FC } from "react"

import { INVOICE_STATUS_LABELS } from "../../constants/labels"

import { InvoiceStatus } from "@/graphql/codegen/graphql"

const INVOICE_STATUS_LIST = Object.values(InvoiceStatus)

interface InvoicesStatusFilterProps {
  statuses: InvoiceStatus[]
  onChange: (statuses: InvoiceStatus[]) => void
}

export const InvoicesStatusFilter: FC<InvoicesStatusFilterProps> = ({ statuses, onChange }) => {
  const handleStatusToggle = (status: InvoiceStatus) => (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange([...statuses, status])
    } else {
      onChange(statuses.filter((selected) => selected !== status))
    }
  }

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {INVOICE_STATUS_LIST.map((status) => (
        <FormControlLabel
          key={status}
          control={
            <Checkbox
              checked={statuses.includes(status)}
              onChange={handleStatusToggle(status)}
              data-testid={`invoices.filter-drawer.status-checkbox-${status}`}
            />
          }
          label={INVOICE_STATUS_LABELS[status]}
          className='w-full text-ellipsis'
        />
      ))}
    </Box>
  )
}
